import { render } from "./MaterialSnackbar.vue?vue&type=template&id=65d5d373"
import script from "./MaterialSnackbar.vue?vue&type=script&lang=js"
export * from "./MaterialSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__